import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchDataFromMicroCMS } from "../utils/microCMSApi";
import CoWorkingNavBar from "./CoWorkingLandingNavBar";
import { useNavigate } from "react-router-dom";

export default function CoWorkingNewsDetail({ newsId }: { newsId: string }) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [newsItem, setNewsItem] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!newsId) {
            navigate("/news");
            return;
        }

        const fetchNews = async () => {
            try {
                const data = await fetchDataFromMicroCMS(`news/${newsId}`);
                setNewsItem(data);
            } catch (error) {
                navigate("/news");
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, [newsId, navigate]);

    const langSuffix = i18n.language === "ja" ? "_ja" : "_en";

    return (
        <div className="w-full text-[#2C2E35]">
            <CoWorkingNavBar />
            {/* Header */}
            <div className="relative mt-20 text-center">
                <h1 className="text-4xl md:text-5xl font-bold leading-[1.1] py-12 text-center items-center">
                    {t("cw_lp_common.news")}
                </h1>
            </div>
            <div className="bg-[#f6f7f9]">
                <div className="w-full max-w-7xl mx-auto p-4">
                    <div className="p-4 text-sm">
                        <a href="/" className="hover:underline">
                            {t("cw_lp_news_detail_1")}
                        </a>
                        <span className="mx-2"> &gt; </span>
                        <a href="/news" className="hover:underline">
                            {t("cw_lp_news_detail_2")}
                        </a>
                        <span className="mx-2"> &gt; </span>
                        <span className="text-gray-700">{newsItem ? newsItem[`title${langSuffix}`] : ''}</span>
                    </div>

                    <div className="px-4 md:px-20 mt-20">
                        {loading ? (
                            <div className="text-center py-8">
                                <p>{t("cw_lp_common.loading")}</p>
                            </div>
                        ) : (
                            newsItem && (
                                <>
                                    <p className="font-bold">{new Date(newsItem.publishedAt).toLocaleDateString()}</p>

                                    <h2 className="text-3xl md:text-4xl font-bold leading-[1.2] mb-4">
                                        {newsItem[`title${langSuffix}`]}
                                    </h2>

                                    <hr className="border-t border-gray-300 mt-20" />

                                    <div className="mx-4 md:mx-10">
                                        <div className="rich-text my-8">
                                            <div dangerouslySetInnerHTML={{ __html: newsItem[`content${langSuffix}`] }} />
                                        </div>

                                        {newsItem.tags?.length > 0 && (
                                            <div className="mt-8">
                                                <h3 className="text-lg font-bold">{t("cw_lp_news_detail_5")}</h3>
                                                <div className="flex flex-wrap gap-2">
                                                    {newsItem.tags?.map((tag: any) => (
                                                        <span key={tag.fieldId || tag} className="border border-gray-300 px-2 py-1 text-sm rounded-md">
                                                            {tag?.tag}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
